export default `
{{#> page inner=1 scroll=1}}
  {{> profile user=user}}
{{/page}}

`;
